export default (props) => (
  /**
   * Ícone utilizado para download das camadas
   * com cor parametrizada.
   * Caminho: CAMADAS + => Catálogo de Camadas.
   */
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.471646 13.3406H10.1031C10.1649 13.341 10.2262 13.3234 10.2834 13.289C10.3407 13.2546 10.3927 13.204 10.4365 13.1401C10.4803 13.0762 10.5151 13.0002 10.5388 12.9166C10.5625 12.8329 10.5747 12.7433 10.5747 12.6527C10.5747 12.5622 10.5625 12.4725 10.5388 12.3889C10.5151 12.3052 10.4803 12.2293 10.4365 12.1654C10.3927 12.1015 10.3407 12.0509 10.2834 12.0164C10.2262 11.982 10.1649 11.9645 10.1031 11.9648H0.471646C0.409795 11.9645 0.348505 11.982 0.291293 12.0164C0.234081 12.0509 0.182073 12.1015 0.138253 12.1654C0.0944327 12.2293 0.0596626 12.3052 0.0359377 12.3889C0.0122128 12.4725 0 12.5622 0 12.6527C0 12.7433 0.0122128 12.8329 0.0359377 12.9166C0.0596626 13.0002 0.0944327 13.0762 0.138253 13.1401C0.182073 13.204 0.234081 13.2546 0.291293 13.289C0.348505 13.3234 0.409795 13.341 0.471646 13.3406Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M4.86296 10.3293C4.97553 10.4389 5.12819 10.5005 5.28737 10.5005C5.44656 10.5005 5.59922 10.4389 5.71178 10.3293L10.4899 5.67426C10.5304 5.6348 10.558 5.58453 10.5692 5.5298C10.5803 5.47507 10.5746 5.41833 10.5527 5.36678C10.5308 5.31522 10.4936 5.27116 10.446 5.24016C10.3984 5.20916 10.3424 5.19261 10.2851 5.19262H7.44337V0.675781H3.13137V5.19262H0.289588C0.232311 5.19262 0.176322 5.20917 0.128699 5.24017C0.081076 5.27118 0.0439589 5.31524 0.0220415 5.36679C0.000124151 5.41835 -0.00560937 5.47507 0.00556579 5.5298C0.016741 5.58453 0.044323 5.6348 0.0848242 5.67426L4.86296 10.3293Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
);
